import { Injectable } from '@angular/core';
import * as config from '../../../../assets/config.json';

@Injectable()
export class SetupService {
  private apiUrl: string;
  private apiBasePath: string;

  constructor() {
    this.apiUrl = config.apiUrl;
    this.apiBasePath = config.apiBasePath;    
  }

  get baseUrl(): string {
    if (this.apiUrl) return `${this.apiUrl}${this.apiBasePath}/`;
    else return `${location.protocol}//${location.host}/${this.apiBasePath}/`; 
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/setup/setup.service.ts